import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TenderModeFilter extends Component {
    state = {
        tenderModeLists:[],
        tenderModeValue: '',
        isTenderModeLoading: true
    };
    componentDidMount(){
        this.getTenderMode();
    }
    restTenderModeFilter() {
        this.setState({
            tenderModeValue: [],
        })
    }
    getTenderMode(){
        axios.get(config.get('API_URL')+'/filters/get-tender-modes/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((tender_mode, index) => {
                    this.state.tenderModeLists.push({value: tender_mode.tender_mode_code, label: tender_mode.tender_mode_display_name})
                });
            }
            this.setState({
                isTenderModeLoading: false
            })
        });

    }


    changeTenderMode(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.tenderModeLists.findIndex(obj => obj.value==ids.value);
                this.state.tenderModeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectTenderMode(optionSelected, tenderArray);
        this.setState({
            tenderModeValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="tender_mode"
                isMulti
                value={this.state.tenderModeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeTenderMode.bind(this)}
                options={this.state.tenderModeLists}
                placeholderButtonLabel="Select [Tender Mode]"
                isLoading={this.state.isTenderModeLoading}
            />
        );

    }
}
export default TenderModeFilter;